import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import ChannelFacebookMessengerInfo from './ChannelFacebookMessengerInfo';
import ChannelFacebookMessengerPageList from './ChannelFacebookMessengerPageList';
import ChannelFacebookMessengerActions from './ChannelFacebookMessengerActions';
import ChannelFacebookMessengerLoginButton from './ChannelFacebookMessengerLoginButton';
/**
 * Component for display the config facebook messenger content correct for the context
 * Render the page list if user is logged in or the information from integration if is not
 *
 * @param {object} props
 * @returns
 */
const ChannelFacebookMessengerContent = (props) => {
  const { i18n, facebookAuth, selectedFacebookPage, channelData } = props;

  /**
   * Render the container main content
   */
  const renderContent = () => {
    if (facebookAuth && facebookAuth.accessToken !== '') {
      return <ChannelFacebookMessengerPageList />;
    }

    if (_.isEmpty(selectedFacebookPage)) {
      return false;
    }

    const { facebookUser } = channelData;
    const { picture, name } = selectedFacebookPage;
    const { height, width, url } = picture.data;
    const imgStyle = { height, width, borderRadius: 50 };
    const { name: userName } = facebookUser;
    // const buttonTitle = `Continuar como ${userName}`;

    return (
      <div className="container-user-integration-info">
        <img
          className="user-integration-content"
          src={url}
          style={imgStyle}
          alt=""
        />
        <p className="user-integration-content user-pages-name">{name}</p>
        <ChannelFacebookMessengerLoginButton
          className="user-integration-content"
          title="Alterar"
        />
      </div>
    );
  };

  return (
    <div>
      <ChannelFacebookMessengerInfo channelData={channelData} />
      <div className="divider-options" />
      <div className="container-user-pages">{renderContent()}</div>
      <ChannelFacebookMessengerActions channelData={channelData} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    facebookAuth: state.facebookMessenger.facebookAuth,
    selectedFacebookPage: state.facebookMessenger.selectedFacebookPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ChannelFacebookMessengerContent))
);
